import { render, staticRenderFns } from "./biaoqian.vue?vue&type=template&id=9e671ffa&"
import script from "./biaoqian.vue?vue&type=script&lang=ts&"
export * from "./biaoqian.vue?vue&type=script&lang=ts&"
import style0 from "./biaoqian.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports